import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import LazyLoad from 'react-lazyload';
import {
  Section,
  SectionHeader,
  Heading,
  Link,
  Button,
  Image,
  YouTubePlayer,
} from 'components';
import './EditorIntro.scss';
import { getCloudinaryUrl, getArticleByName } from 'config/helpers';
import {
  SinglePostTile,
  SinglePostTileBig,
  SinglePostTileLead,
  BlogNewsletter,
} from '..';
import config from '../../../../../meta/config';

class EditorInfo extends Component {
  render() {
    const { posts, contributors, toggleFilter } = this.props;
    const { mainBanner, editorsPick } = config.blog;
    const {
      topLeftTile,
      topRightTile,
      bottomLeftTile,
      bottomCenterTile,
      videoTile,
    } = editorsPick;

    const firstArticle = getArticleByName(topLeftTile, posts);
    const secondArticle = getArticleByName(topRightTile, posts);
    const thirdArticle = getArticleByName(bottomLeftTile, posts);
    const fourthArticle = getArticleByName(bottomCenterTile, posts);

    return (
      <div className={'editor-intro'}>
        <Section
          color={'gray-light'}
          additionalClass={'editor-intro__banner'}
          spaceless
        >
          <Link to={mainBanner.url} arrow>
            <div className={'editor-intro__banner-intro'}>
              <Heading
                color={'mine-shaft'}
                size={'large'}
                type={2}
                additionalClass={
                  'text--bold editor-intro__background-headline'
                }
              >
                <span>{mainBanner.title}</span>
                <br />
                {mainBanner.subtitle}
              </Heading>
              <Button color={'white'}>{mainBanner.buttonText}</Button>
            </div>
            <div className={'editor-intro__banner-image-wrapper'}>
              <LazyLoad once offset={200}>
                <Image
                  src={getCloudinaryUrl(mainBanner.image, 'f_auto,q_auto,w_1000')}
                  alt={`${mainBanner.title} ${mainBanner.subtitle} article`}
                  additionalClass={'editor-intro__banner-image'}
                  placeholder
                />
              </LazyLoad>
            </div>
          </Link>
        </Section>

        <Section color={'mine-shaft'}>
          <SectionHeader
            lineColor={'yellow'}
            size={'big'}
            color={'white'}
            fixed
          >
            Editor’s pick
          </SectionHeader>
          <Row className={'no-gap editor-intro__row'}>
            <LazyLoad once offset={200}>
              <SinglePostTileBig
                post={firstArticle}
                contributors={contributors}
                toggleFilter={toggleFilter}
                theme={'black'}
              />

              <BlogNewsletter />

              <SinglePostTile
                post={thirdArticle}
                contributors={contributors}
                toggleFilter={toggleFilter}
                theme={'black'}
              />

              <SinglePostTileLead
                backgroundColor={'red'}
                post={fourthArticle}
                contributors={contributors}
                toggleFilter={toggleFilter}
                theme={'black'}
              />

              <Col sm={12} md={6} lg={4}>
                <YouTubePlayer title={videoTile.title} src={videoTile.url} />
              </Col>
            </LazyLoad>
          </Row>
        </Section>
      </div>
    );
  }
}

export default EditorInfo;
